const SessionService = {
    get: (key: string) => window.localStorage.getItem(key),
    set: (key: string, value: string) =>
        window.localStorage.setItem(key, value),
    remove: (key: string) => window.localStorage.removeItem(key),
    clear: () => window.localStorage.clear(),
};

export default SessionService;
